import { withStyles, withTheme } from 'material-ui';
import React, { Component } from 'react';
import Page from '../components/Page';
import DocumentContent from '../resource_content/DocumentContent';
import AppBarSpacing from '../utils/AppBarSpacing';

class Document extends Component {
  render() {
    return (
      <Page containerProps={{className: this.props.classes['margin-app_bar_spacing-1']}}>
        <main style={{marginTop: 16}}>
          <DocumentContent resourceID={this.props.resourceID} resources={this.props.resources}/>
        </main>
      </Page>
    );
  }
}

export default withTheme()(withStyles(AppBarSpacing)(Document));


// WEBPACK FOOTER //
// ./src/resource_views/Document.js